import { useEffect } from 'react'
import { KTIcon } from '../../../../_metronic/helpers'
import { CreateVoucherModalForm } from './CreateVoucherModalForm'

const CreateVoucherModal = ({
  setOpenCreateVoucherModal,
  fetchVouchers
}) => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])


  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        <div className={`modal-dialog modal-dialog-centered mw-650px`}>
          <div className='modal-content'>
            <div className='modal-header py-3'>
              <h2 className='fw-bolder mb-0'>Create Voucher</h2>
              <div
                className='btn btn-icon btn-sm btn-active-icon-primary'
                data-kt-users-modal-action='close'
                onClick={() => {
                  setOpenCreateVoucherModal(false)
                }}
                style={{ cursor: 'pointer' }}
              >
                <KTIcon iconName='cross' className='fs-1' />
              </div>
            </div>
            <div className={`modal-body scroll-y mx-5 mx-xl-15 my-7`}>
              <CreateVoucherModalForm setOpenCreateVoucherModal={setOpenCreateVoucherModal} fetchVouchers={fetchVouchers} />
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  )
}

export { CreateVoucherModal }
